const React = require('react');
const { useState } = require('react');
const T = require('prop-types');

const { default: Button } = require('@mui/material/Button');
const { default: Typography } = require('@mui/material/Typography');
const { default: Tab } = require('@mui/material/Tab');
const { default: Tabs } = require('@mui/material/Tabs');
const { default: List } = require('@mui/material/List');
const { default: ListItemText } = require('@mui/material/ListItemText');
const { default: Select } = require('@mui/material/Select');
const { default: MenuItem } = require('@mui/material/MenuItem');
const { NavLink: Link } = require('react-router-dom');

const SurveyListItem = require('../SurveyListItem');
const SelectFormControl = require('components/SelectFormControl');
const SelectInputLabel = require('components/SelectInputLabel');

const { default: Classes } = require('./styles.scss');
const LoadingScreen = require('components/LoadingScreen');
const { default: DialogTitle } = require('@mui/material/DialogTitle');
const { default: DialogContent } = require('@mui/material/DialogContent');
const { default: DialogContentText } = require('@mui/material/DialogContentText');
const { default: DialogActions } = require('@mui/material/DialogActions');
const { default: Dialog } = require('@mui/material/Dialog');
const { default: Styled } = require('styled-components');

const { SURVEYS_SORT_TYPE } = require('utils/constants');

const internals = {};

const SurveysManagement = (props) => {

    const {
        surveys,
        surveysIsLoading,
        rolePermissions,
        deleteSurvey,
        surveysManagementFilter,
        setSurveysManagementFilter,
        surveysSortType,
        setSurveysSortType,
        stopSurvey,
        inviteUsers,
        searchResults,
        activeSearchFilter,
        interestsActiveFilter_survey,
        badges,
        departments,
        yearsHiredList,
        officesList,
        isCompany,
        isCommunity,
        isSchoolOnline,
        schoolRoles,
        schoolRoleGroups,
        onClickResetSearchFilters,
        schoolId
    } = props;

    const {
        StyledTabs,
        StyledTab,
        FiltersRow,
        FiltersContainer
    } = internals;

    const { canCreateSurveys, canSeeSurveysReports } = rolePermissions;
    const [surveyDialogOpen, setSurveyDialogOpen] = useState(false);
    const [surveyDialogAction, setSurveyDialogAction] = useState('');
    const [surveyDialog, setSurveyDialog] = useState(null);

    const handleInviteUsers = (data) => {

        const selectedUsers = data.selectedUsers?.map((user) => parseInt(user.id)) || [];
        const selectedIds = new Set(selectedUsers);

        return inviteUsers({
            surveyId: data.surveyId,
            selectedRole: data.selectedRole,
            selectedUsers,
            ...(data.selectedRole === 'search' && activeSearchFilter && Object.keys(activeSearchFilter).length ? {
                usedCriteria: activeSearchFilter,
                excludedUserIds: searchResults
                    .map(({ id }) => Number(id))
                    .filter((id) => !selectedIds.has(id))
            } : {})
        });
    };

    const onTabChange = (event, val) => {

        setSurveysManagementFilter({
            filter: val
        });
    };

    const handleSortFilterChange = (event) => {

        const value = event.target.value;

        setSurveysSortType({
            sortType: value
        });
    };

    const onDeleteSurvey = (survey) => {

        setSurveyDialogAction('Delete Survey');
        setSurveyDialog(survey);
        setSurveyDialogOpen(true);
    };

    const onStopSurvey = (survey) => {

        setSurveyDialogAction('Stop Survey');
        setSurveyDialog(survey);
        setSurveyDialogOpen(true);
    };

    const sortSurveys = (_surveys) => {

        const sortFilter = surveysSortType;

        return _surveys.sort((survey1, survey2) => {

            if (sortFilter === SURVEYS_SORT_TYPE.BY_NAME) {
                const getFirstChar = (title) => {

                    const match = title.match(/[a-zA-Z0-9]/);
                    return match ? title.substring(title.indexOf(match[0])) : title;
                };

                const title1 = getFirstChar(survey1.title);
                const title2 = getFirstChar(survey2.title);

                return title1.localeCompare(title2);
            }

            if (!survey1.startDate && !survey2.startDate) {
                return 0;
            }

            if (!survey1.startDate) {
                return 1;
            }

            if (!survey2.startDate) {
                return -1;
            }

            const date1 = new Date(survey1.startDate);
            const date2 = new Date(survey2.startDate);

            return date2 - date1;
        });
    };

    const filteredSurveys = !surveysIsLoading ? surveys.filter((survey) => {

        return survey.status === surveysManagementFilter;
    }) : [];

    const sortedSurveys = sortSurveys(filteredSurveys);

    return (
        <div className={Classes.wrapper}>
            <div className={Classes.header}>
                <Typography variant='h2' className={Classes.headerTitle}>
                    Survey Management
                </Typography>
                <Link style={{ textDecoration: 'none' }} to={'/app/surveys/create'} >
                    <Button
                        variant={'contained'}
                        color="secondary"
                        className={Classes.createNewButton}
                    >
                        Create new
                    </Button>
                </Link>
            </div>
            <FiltersContainer>
                <FiltersRow>
                    <SelectFormControl style={{ width: 150 }}>
                        <SelectInputLabel id='sort-label'>
                            Show By:
                        </SelectInputLabel>
                        <Select
                            value={surveysSortType}
                            onChange={handleSortFilterChange}
                            labelId='sort-label'
                            inputProps={{
                                'aria-labelledby': 'sort-label'
                            }}
                        >
                            <MenuItem value={SURVEYS_SORT_TYPE.BY_DATE_UPDATED}>
                                <ListItemText
                                    primary='Most Recent'
                                    primaryTypographyProps={{
                                        align: 'left'
                                    }}
                                />
                            </MenuItem>
                            <MenuItem value={SURVEYS_SORT_TYPE.BY_NAME}>
                                <ListItemText
                                    primary='Survey Name'
                                    primaryTypographyProps={{
                                        align: 'left'
                                    }}
                                />
                            </MenuItem>
                        </Select>
                    </SelectFormControl>
                </FiltersRow>
            </FiltersContainer>
            <StyledTabs
                value={surveysManagementFilter}
                onChange={onTabChange}
                variant="fullWidth"
                selectionFollowsFocus
            >
                <StyledTab
                    label='Active'
                    value='active'
                    key='active'
                />
                <StyledTab
                    label='Upcoming'
                    value='upcoming'
                    key='upcoming'
                />
                <StyledTab
                    label='Finished'
                    value='finished'
                    key='finished'
                />
            </StyledTabs>
            {surveysIsLoading ?
                <LoadingScreen variant='content' /> :
                <List >
                    {sortedSurveys.map((survey) => {

                        return <SurveyListItem
                            key={survey.id}
                            survey={survey}
                            canEdit={canCreateSurveys}
                            canSeeReport={canSeeSurveysReports}
                            showStart={false}
                            onDelete={onDeleteSurvey}
                            onStop={onStopSurvey}
                            schoolId={schoolId}
                            onInviteUsers={handleInviteUsers}
                            searchResults={searchResults}
                            activeSearchFilter={activeSearchFilter}
                            interestsActiveFilter_survey={interestsActiveFilter_survey}
                            badges={badges}
                            departments={departments}
                            yearsHiredList={yearsHiredList}
                            officesList={officesList}
                            isCompany={isCompany}
                            isCommunity={isCommunity}
                            isSchoolOnline={isSchoolOnline}
                            schoolRoles={schoolRoles}
                            schoolRoleGroups={schoolRoleGroups}
                            onClickResetSearchFilters={onClickResetSearchFilters}
                            showSchoolInfo={true}
                            invitedUsersCount={survey.invitedUsersCount}
                        />;
                    })}
                </List>
            }
            <Dialog
                open={surveyDialogOpen}
                onClose={() => {

                    setSurveyDialogOpen(false);

                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-message"
            >
                <DialogTitle id="alert-dialog-title">{surveyDialogAction}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-message">
                        {surveyDialogAction === 'Delete Survey' ? `Are you sure you want to delete the survey "${surveyDialog && surveyDialog.title}"?` : `Are you sure you want to stop the survey "${surveyDialog && surveyDialog.title}"?`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {

                        setSurveyDialogOpen(false);
                        if (surveyDialogAction === 'Delete Survey') {
                            deleteSurvey({
                                surveyId: surveyDialog && surveyDialog.id
                            });
                        }
                        else {
                            stopSurvey({
                                surveyId: surveyDialog && surveyDialog.id
                            });
                        }
                    }} color="secondary" autoFocus>
                        Yes
                    </Button>
                    <Button onClick={() => {

                        setSurveyDialogOpen(false);
                    }} color="primary" autoFocus>
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

SurveysManagement.propTypes = {
    surveys: T.array,
    rolePermissions: T.shape({
        id: T.number,
        name: T.string,
        label: T.string,
        schoolId: T.number,
        canCreateSurveys: T.bool,
        canSeeSurveysReports: T.bool
    }),
    surveysIsLoading: T.bool,
    surveysManagementFilter: T.oneOf(['active','upcoming','finished']),
    setSurveysManagementFilter: T.func,
    surveysSortType: T.string,
    setSurveysSortType: T.func,
    stopSurvey: T.func,
    deleteSurvey: T.func,
    // Add new prop types
    inviteUsers: T.func,
    searchResults: T.array,
    activeSearchFilter: T.object,
    interestsActiveFilter_survey: T.array,
    badges: T.array,
    departments: T.array,
    yearsHiredList: T.array,
    officesList: T.array,
    isCompany: T.bool,
    isCommunity: T.bool,
    isSchoolOnline: T.bool,
    schoolRoles: T.array,
    schoolRoleGroups: T.array,
    onClickResetSearchFilters: T.func,
    schoolId: T.number
};

module.exports = SurveysManagement;

internals.FiltersRow = Styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
`;

internals.StyledTabs = Styled(Tabs)`
    &.MuiTabs-root {
      background: ${({ theme }) => theme.palette.primary.main};
      color: #ffffff;
      margin-bottom: 0.5rem;
    }

    &.MuiTabs-flexContainer {
        flex-wrap: wrap;
    }
`;

internals.StyledTab = Styled(Tab)`
    &.MuiTab-root {
      min-width: 100px;
    }

    overflow: hidden;
    display: block;
    white-space:nowrap;
    text-overflow:ellipsis;
`;

internals.FiltersContainer = Styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0px 32px;
`;
